import { render, staticRenderFns } from "./top-five-most-active-participant.vue?vue&type=template&id=0abf7564&"
import script from "./top-five-most-active-participant.vue?vue&type=script&lang=js&"
export * from "./top-five-most-active-participant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "top-five-most-active-participant.vue"
export default component.exports